<div class="ancillary-price">
  <span class="heather-700-text bold-type font-heading-2">{{ price | finPrice }}</span>
  <span class="pr-xsmall-l nordic-blue-900-text font-body-1">{{ title | finLocalization }}</span>
</div>
<div class="ancillary-price-info font-body-1 nordic-blue-900-text pr-medium-b">
  {{ disclaimer | finLocalization }}
</div>
